import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const measurement = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    x1: z
      .number()
      .nullable()
      .optional()
      .describe('X pixel coordinate of the first endpoint.'),

    y1: z
      .number()
      .nullable()
      .optional()
      .describe('Y pixel coordinate of the first endpoint.'),

    x2: z
      .number()
      .nullable()
      .optional()
      .describe('X pixel coordinate of the second endpoint.'),

    y2: z
      .number()
      .nullable()
      .optional()
      .describe('Y pixel coordinate of the second endpoint.'),

    pixelLength: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe('Line length in pixels, computed from the endpoints.'),

    scaledLength: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe(
        'Real-world length in inches, derived from pixelLength × MeasurementSet.scaleFactor.',
      ),

    measurementSetId: z
      .number()
      .hidden()
      .describe('Foreign key to MeasurementSet'),

    measurementTypeId: z
      .number()
      .hidden()
      .presentAs('reference')
      .describe('Foreign key to MeasurementType'),

    measurementSet: belongsTo('MeasurementSet'),

    measurementType: references('MeasurementType'),
  })
  .describe(
    'A single line drawn on a sale photo for a given measurement type — the two\nendpoint pixel coordinates and the resulting pixel length.',
  )
  .as('Measurement');

export { measurement as measurementSchema };
